import { takeLatest, put, fork, takeEvery, takeLeading } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import NetworkHandler from 'utils/network';
import Auth from 'utils/auth';
import { firebase } from 'utils/firebase';
import config from 'config';
import { actions as notificationActions } from '../slices/NotificationSlice';
import { actions as authActions } from 'modules/auth/slices/authSlice';
import NotificationHandler from 'utils/notification';
// const DEFAULT_LIMIT = 20;
// const DEFAULT_PAGE = 0;
// const DEFAULT_FILTER = {
//     page: DEFAULT_PAGE,
//     size: DEFAULT_LIMIT,
//     app_type: 'ADMIN_CITY_BUS',
//     type: 150,
// };
function initializeBroadcastChannel() {
    const bc = new BroadcastChannel('notification_channel');
    return eventChannel((emitter) => {
        const listener = (bc.onmessage = (event) => {
            emitter(event);
        });

        return listener;
    });
}

async function initializeFCM() {
    const messaging = firebase.messaging();
    messaging.usePublicVapidKey(config.FIREBASE_VAPID);
    messaging.onTokenRefresh(() => {
        messaging
            .getToken()
            .then(handleFCMToken)
            .catch(() => null);
    });
    return eventChannel((emitter) => {
        const listener = messaging.onMessage((payload) => {
            emitter(payload);
        });
        return listener;
    });
}

async function handleFCMToken(deviceToken) {
    try {
        if (deviceToken) {
            const payload = { deviceToken };
            await NetworkHandler.post(config.getUrl('device_token', 1), payload, null, true, {
                'x-app-id': config.X_APP_ID,
            });
            Auth.setDeviceToken(deviceToken);
        }
    } catch (error) {
        return false;
    }
}

function* getNotification(action) {
    const { payload } = action;
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('get_list_notify', 1)}`, {
            params: {
                ...payload,
            },
        });
        yield put({ type: notificationActions.get_list_succeed.type, payload: { items: response?.data?.notifications, total: response?.data?.total, more: response?.data?.more } });
    } catch (error) {
        yield put({ type: notificationActions.get_list_failed.type, payload: error });
    }
}

function* readNotification(action) {
    const { payload } = action;
    try {
        yield NetworkHandler.put(`${config.getUrl('get_list_notify', 1)}/` + payload?.id);
        yield put({ type: notificationActions.mark_read_succeed.type, payload: payload?.id });
    } catch (error) {
        yield put({ type: notificationActions.get_list_failed.type, payload: error });
    }
}

function* getToken() {
    const permission = yield Notification.requestPermission();
    if (permission === 'granted') {
        yield firebase
            .messaging()
            .getToken()
            .then(handleFCMToken)
            .catch(() => null);
    } else {
        yield NotificationHandler.notifyBoxInfo('Bạn chưa bật thông báo', 'Vui lòng bật thông báo để nhận thông tin hỗ trợ');
    }
}

function* deleteToken() {
    const result = yield firebase.messaging().deleteToken(Auth.getDeviceToken());
    return result;
}

function* handleReceiveNotification(payload) {
    NotificationHandler.notifyInfo('Bạn có một thông báo mới từ hỗ trợ khách hàng!');
}

function* handleReceiveNotificationOnBackground(payload) {
    console.log(payload);
}

//

function* startPushNotificationService() {
    if (window.Notification) {
        const listener = yield initializeFCM();
        // const broadcastListener = yield initializeBroadcastChannel();
        yield takeEvery(listener, handleReceiveNotification);
        // yield takeEvery(broadcastListener, handleReceiveNotificationOnBackground);
        yield takeLeading([authActions.login_firebase_succeed.type, authActions.id_token_changed.type], getToken);
        yield takeLeading([authActions.logout_succeed.type, authActions.load_user_failed.type], deleteToken);
    }
}

function* watchRequestDetail() {
    yield fork(startPushNotificationService);
    yield takeLatest(notificationActions.get_list.type, getNotification);
    yield takeLatest(notificationActions.mark_read.type, readNotification);
}

export default watchRequestDetail;
